import { render, staticRenderFns } from "./ExamPrepExam.vue?vue&type=template&id=2756af2c"
import script from "./ExamPrepExam.vue?vue&type=script&lang=js"
export * from "./ExamPrepExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports